"use strict";

(() => {
    /**
     * @see https://medium.com/@diogobv.batista/a-story-about-a-graph-part-1-77fc29977322
     */
    class Rent_Sentence_2 {
        /** @var {HTMLElement} */
        #$widget;

        /** @var {HTMLInputElement} */
        #$initialDepositInput;

        /** @var {HTMLSelectElement} */
        #$periodInput;

        /** @var {HTMLInputElement} */
        #$depositInput;

        /** @var {HTMLInputElement} */
        #$rentInput;

        /** @var {HTMLInputElement} */
        #$interestInput;

        /** @var {HTMLInputElement} */
        #$withdrawInput;

        /** @var {HTMLElement} */
        #$resultWrapper

        /** @var {HTMLElement} */
        #$resultPeriod;

        /** @var {HTMLElement} */
        #$resultValue;


        constructor($widget) {
            this.#$widget = $widget;
        }

        initialize() {
            this.#$initialDepositInput = this.#$widget.querySelector(".dan-input-initial-deposit");
            this.#$periodInput         = this.#$widget.querySelector(".dan-input-period");
            this.#$depositInput        = this.#$widget.querySelector(".dan-input-deposit");
            this.#$rentInput           = this.#$widget.querySelector(".dan-input-rent");
            this.#$withdrawInput       = this.#$widget.querySelector(".dan-input-withdraw");
            this.#$interestInput       = this.#$widget.querySelector(".dan-input-interest");
            this.#$resultWrapper       = this.#$widget.querySelector(".dan-sentence-result-wrap");
            this.#$resultPeriod        = this.#$widget.querySelector(".dan-sentence-result.-period");
            this.#$resultValue         = this.#$widget.querySelector(".dan-sentence-result.-value");

            this.#$widget.addEventListener("submit", (this.#onFormSubmit).bind(this));
            this.#$periodInput.addEventListener("change", (this.#onPeriodChange).bind(this));
        }

        #onPeriodChange() {
            const newDepositAttrName  = "data-default-deposit-" + this.#$periodInput.value;
            const newDepositAttrValue = this.#$widget.getAttribute(newDepositAttrName);

            if (newDepositAttrValue) {
                this.#$depositInput.placeholder = newDepositAttrValue;
            }
        }

        /**
         * @param {SubmitEvent} event
         */
        #onFormSubmit(event) {
            event.preventDefault();

            // Load inputs.
            const inputs = this.getInputs();

            if (
                inputs.initialDeposit === null
                || inputs.deposit === null
                || inputs.rent === null
                || inputs.interest === null
                || inputs.withdraw === null
            ) {
                alert("Prosím, vyplňte všechna pole.");
                return;
            }

            // Calc and format results.
            const result = this.calcResult(inputs);

            if (result === null) {
                alert("Doba investice pro zadané parametry by byla příliš dlouhá. Prosím, upravte parametry na více reálné.");
                return;
            }

            const resultPeriodFormatted = this.formatResult(result);
            const resultValueFormatted  = Dan_Utilities.formatPrice(result.value) + " Kč";

            // Calc and format results.
            if (this.#$resultWrapper.classList.contains("-active")) {
                this.slideResultUp(() => {
                    this.#$resultPeriod.textContent = resultPeriodFormatted;
                    this.#$resultValue.textContent  = resultValueFormatted;
                    this.slideResultDown();
                });
            } else {
                this.#$resultPeriod.textContent = resultPeriodFormatted;
                this.#$resultValue.textContent  = resultValueFormatted;
                this.slideResultDown();
            }
        }

        /**
         * @param {object} inputs
         * @returns {object|null}
         */
        calcResult(inputs) {
            const targetValue       = (inputs.rent * 12 / inputs.withdraw * 100);
            const interestCoeff     = (inputs.interest / 100 / 12);
            const monthlyInvestment = (inputs.period === "year")
                ? Math.round(inputs.deposit / 12)
                : inputs.deposit;

            let months = 0;
            let monthsValue;

            do {
                months     += 1;
                monthsValue = this.calcInvestmentValue(
                    inputs.initialDeposit,
                    monthlyInvestment,
                    interestCoeff,
                    months
                );

                if (monthsValue >= targetValue) {
                    return {
                        years: Math.floor(months / 12),
                        months: (months % 12),
                        value: monthsValue
                    };
                }
            } while (months < 2400); // 2400 months = 200 years.

            return null;
        }

        /**
         * @param {number} initialDeposit
         * @param {number} monthlyInvestment
         * @param {number} interestCoeff
         * @param {number} months
         * @returns {number}
         */
        calcInvestmentValue(
            initialDeposit,
            monthlyInvestment,
            interestCoeff,
            months
        ) {
            let value = initialDeposit;

            for (let month = 1; month <= months; month++) {
                value += monthlyInvestment;
                value += (value * interestCoeff);
            }

            return value;
        }

        /**
         * @param {object} result
         * @return {string}
         */
        formatResult(result) {
            // Years.
            let formattedYears = "";

            if (result.years === 1) {
                formattedYears = result.years + " rok";
            } else if (result.years > 1 && result.years < 5) {
                formattedYears = result.years + " roky";
            } else if (result.years > 0) {
                formattedYears = result.years + " let";
            }

            // Months.
            let formattedMonths = "";

            if (result.months === 1) {
                formattedMonths = result.months + " měsíc";
            } else if (result.months > 1 && result.months < 5) {
                formattedMonths = result.months + " měsíce";
            } else if (result.months > 0) {
                formattedMonths = result.months + " měsíců";
            }

            // Return result.
            if (formattedYears && formattedMonths) {
                return formattedYears + " a " + formattedMonths;
            } else {
                return formattedYears || formattedMonths;
            }
        }

        slideResultUp(callback = null) {
            this.#$resultWrapper.style.height = this.#$resultWrapper.scrollHeight + "px";

            setTimeout(() => {
                this.#$resultWrapper.style.height = "0";
            }, 25);

            setTimeout(() => {
                this.#$resultWrapper.classList.remove("-active");

                if (typeof callback === "function") {
                    callback();
                }
            }, 175);
        }

        slideResultDown(callback = null) {
            this.#$resultWrapper.style.height = this.#$resultWrapper.scrollHeight + "px";

            setTimeout(() => {
                this.#$resultWrapper.style.height = "auto";
                this.#$resultWrapper.classList.add("-active");

                if (typeof callback === "function") {
                    callback();
                }
            }, 150);
        }

        getInputs() {
            // Initial deposit.
            let initialDeposit;
            initialDeposit = this.#$initialDepositInput.value || this.#$initialDepositInput.placeholder;
            initialDeposit = parseInt(initialDeposit);

            if (isNaN(initialDeposit) || initialDeposit < 0) {
                initialDeposit = null;
            }

            // Period.
            let period = this.#$periodInput.value;

            if (period !== "month" && period !== "year") {
                period = "month";
            }

            // Deposit.
            let deposit;
            deposit = this.#$depositInput.value || this.#$depositInput.placeholder;
            deposit = parseInt(deposit);

            if (isNaN(deposit) || deposit < 1) {
                deposit = null;
            }

            // Rent.
            let rent;
            rent = this.#$rentInput.value || this.#$rentInput.placeholder;
            rent = parseInt(rent);

            if (isNaN(rent) || rent < 1) {
                rent = null;
            }

            // Interest.
            let interest;
            interest = this.#$interestInput.value || this.#$interestInput.placeholder;
            interest = parseFloat(interest);

            if (!isNaN(interest) && interest >= 0) {
                interest = (Math.round(interest * 100) / 100);
            } else {
                interest = null;
            }

            // Withdraw.
            let withdraw;
            withdraw = this.#$withdrawInput.value || this.#$withdrawInput.placeholder;
            withdraw = parseFloat(withdraw);

            if (!isNaN(withdraw) && withdraw >= 0.1 && withdraw <= 100) {
                withdraw = (Math.round(withdraw * 10) / 10);
            } else {
                withdraw = null;
            }

            // Return.
            return {
                initialDeposit: initialDeposit,
                period: period,
                deposit: deposit,
                rent: rent,
                interest: interest,
                withdraw: withdraw
            };
        }
    }

    // Initialize widgets.
    const $widgets = document.querySelectorAll("form.dan-rent-sentence-2");

    for (const $widget of $widgets) {
        $widget.calculator = new Rent_Sentence_2($widget);
        $widget.calculator.initialize();
    }
})();
